module.exports = __webpack_public_path__ + "img/zuzhititle2.48106113.png";